module.exports = __webpack_public_path__ + "static/media/shift-left.535f15af.svg";